import { Box } from "@mui/material";
import { useContext } from "react";

import InvalidUser from "@/components/InvalidUser";
import TemplateContainer from "@/components/Templates/TemplateContainer.tsx";
import { DataContext } from "@/models/DataProvider.tsx";
export default function TemplateManagement() {
  const { availableWorkspaceRoles } = useContext(DataContext);
  return (
    <>
      <InvalidUser
        validRoles={[availableWorkspaceRoles?.get("admin")?.role, availableWorkspaceRoles?.get("member")?.role]}
      />
      <Box
        sx={{
          maxWidth: "auto",
          mx: "auto",
          height: "100%",
          overflow: "hidden",
        }}
      >
        <TemplateContainer showRightPanel={false} header={true} />
      </Box>
    </>
  );
}
